import { EndpointContract } from '@ublend-npm/aula-schema';
import { HOME_SPACES_PROGRESS } from '../../constants/endpoints';
import { HomeSpaceProgressApiItem } from '../../types/state';
import request from '../request';

export type GetHomeSpacesProgressResponse = {
  spaceProgress: HomeSpaceProgressApiItem[];
};

type GetHomeSpacesProgressContract = EndpointContract & {
  query: {
    spaceIds?: string;
  };
  responseBody: GetHomeSpacesProgressResponse;
};

const getHomeSpacesProgress = async (
  spaceIds: string[]
): Promise<GetHomeSpacesProgressResponse> => {
  if (!spaceIds.length) {
    return { spaceProgress: [] };
  }

  const { data, status } = await request<GetHomeSpacesProgressContract>({
    method: 'get',
    url: HOME_SPACES_PROGRESS(spaceIds),
  });

  if (status !== 200) {
    throw new Error(`Home spaces progress fetch non 200: ${status}`);
  }

  return data;
};

export default getHomeSpacesProgress;
